import React from 'react';
import { useSelector } from 'react-redux';
import { ButtonType } from '../../../../../ui/buttonTypes';
import BtnComponent from '../../../../ui/buttons/BtnComponent';
import ItemBlock from '../../itemBlock/ItemBlock';
import Icon from '../../../../ui/icons/Icon';
import iconsList from '../../../../ui/icons/iconsList';
import classes from './StarsChallengeBlock.module.css';

const StarsChallengeBlock = ({ title, text, image, button, link, textImg, registrationMessage }) => {

    const { texts, lang } = useSelector(state => state.translate);

    return (
        <ItemBlock title={title ? (texts[title] || title) : null} icon={<img src={textImg?.src[lang ?? 'he']} className={classes.headerLogo} alt="" />}  >
            <div className={classes.content}>
                {image &&
                    <div className={classes.imageContainer}>
                        <img src={image.src} alt={image.alt || ''} className={classes.image} />
                    </div>
                }
                <div className={classes.leftArea}>
                    {textImg && (
                        <img src={textImg.src[lang ?? 'he']} className={classes.logo} alt="" />
                    )}
                    {text && <p className={classes.text}>{texts[text] || text}</p>}
                    {registrationMessage &&
                        <div className={classes.registrationMessage}>
                            <Icon name={iconsList.check} size="24px" />
                            <div className={classes.registrationText}>
                                {registrationMessage.line1 && <p className={classes.registrationTextBold}>{texts[registrationMessage.line1] || registrationMessage.line1}</p>}
                                {registrationMessage.line2 && <p className={classes.registrationTextNormal}>{texts[registrationMessage.line2] || registrationMessage.line2}</p>}
                            </div>
                        </div>
                    }
                    <div className={classes.actions}>
                        {
                            button &&
                            <BtnComponent
                                type={button.type}
                                text={texts[button.text] || button.text}
                                bgcolor={button.color}
                                className={classes.button}
                                icon={button.icon}
                                {...button?.props}
                            />
                        }
                        {link &&
                            <BtnComponent type={ButtonType.REGULATIONS} text={texts[link.text] || link.text} className={classes.link} />
                        }
                    </div>
                </div>
            </div>
        </ItemBlock>
    );
};

export default StarsChallengeBlock;

